import { required, optional, obj, array } from "AppReact/schema";

export const singleVideoState = {
  id: optional("integer"),
  video_filename: required("string"),
  title: required("string"),
  titleError: required("string"),
  alt_text: required("string"),
  altError: required("string"),
  description: required("string"),
  descriptionError: required("string"),
  transcript: required("string"),
  transcriptError: required("string"),
  personId: required("string"),
  personIdError: required("string"),
  categoryId: required("string"),
  categoryIdError: required("string"),
  selectedTags: array("integer"),
  selectedTagsError: required("string"),
  isFeaturedVideo: required("boolean"),
  num_views: required("string"),
  video: obj({
    file: obj({
      filename: required("string"),
      type: required("string"),
    }),
    url: required("string"),
    uuid: required("string"),
    filename: required("string"),
    duration:  required("string"),
  }),
  videoThumbnail: obj({
    url: required("string"),
    uuid: required("string"),
    filename: required("string"),
  }),
};


export const trainingVideoModal = {
  isVisible: required("boolean"),
  ...singleVideoState,
};

export const singleVideoDefaultValue = {
  id: null,
  video_filename: "",
  title: "",
  titleError: "",
  alt_text: "",
  altError: "",
  description: "",
  descriptionError: "",
  transcript: "",
  transcriptError: "",
  personId: "",
  personIdError: "",
  categoryId: "",
  categoryIdError: "",
  isFeaturedVideo: false,
  selectedTags: [],
  selectedTagsError: "",
  num_views: "",
  video: {
    file: {
      filename: "",
      type: "",
    },
    uuid: "",
    url: "",
    filename: "",
    duration: "",
  },
  videoThumbnail: {
    uuid: "",
    url: "",
    filename: "",
  },
};

export const trainingVideoModalDefaultValue = {
  isVisible: false,
  ...singleVideoDefaultValue,
};
